module.exports = __webpack_public_path__ + "img/phone-landscape-fill.c6f93170.svg";